module.exports = __webpack_public_path__ + "static/media/certificate.ecc4a81b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certificate.png
// module id = 1603
// module chunks = 0